import { useMemo } from 'react'
import { WbProductVariant } from '~/@types/product'

type FallbackVariantsProps = {
  baseVariants: WbProductVariant[]
  baseDefaultVariant: WbProductVariant
  updatedVariants: WbProductVariant[]
  updatedDefaultVariant: WbProductVariant
  isUpdatedVariantsLoaded: boolean
  isVariantsEqual: boolean
}

export default function useFallbackVariants({
  baseVariants,
  baseDefaultVariant,
  updatedVariants,
  updatedDefaultVariant,
  isUpdatedVariantsLoaded,
  isVariantsEqual,
}: FallbackVariantsProps) {
  const memorizedValues = useMemo(() => {
    let variantsToUse = baseVariants
    let defaultVariantToUse = baseDefaultVariant

    // If I'm fully done loading variants
    if (isUpdatedVariantsLoaded) {
      // If the variants from the rest part and the updated ones are not deeply equal
      if (!isVariantsEqual) {
        // Then I'm attributing the variables to the updated ones I got from the server directly
        defaultVariantToUse = updatedDefaultVariant
        variantsToUse = updatedVariants
      }
    }

    return {
      isVariantsEqual,
      isUpdatedVariantsLoaded,
      variants: variantsToUse,
      defaultVariant: defaultVariantToUse,
    }
  }, [isUpdatedVariantsLoaded, isVariantsEqual])

  return {
    fallbackVariantValues: memorizedValues,
    compiledVariantProps: {
      ...(memorizedValues?.isVariantsEqual &&
      memorizedValues?.isUpdatedVariantsLoaded
        ? {}
        : {
            variants: memorizedValues?.variants,
            defaultVariant: memorizedValues?.defaultVariant,
          }),
    },
  }
}
